import { useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import * as icons from 'react-bootstrap-icons';
import CButton from 'Utils/Helpers/CButton';
import { HandleLoading } from 'Utils/Helpers/HandleLoading';

export default function LackInformation({}) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const backToSetting = () => {
        dispatch(HandleLoading(true));
        setTimeout(() => {
            navigate('/dashboard/setting/types');
            dispatch(HandleLoading(false));
        }, 600);
    }
    return (
        <>
            <DialogContent>
                <strong className='mb-2'>
                    {"کاربر گرامی"}
                </strong>
                <p className='mb-1'>
                    {"تنظیمات مربوط به نوع‌های نوبت انجام نشده است"}
                </p>
                <p className='mb-2'>
                    {"به بخش تنظیمات رفته و نوع‌های مربوط به مطب خود را ثبت کنید و پس از آن اقدام به ثبت نوبت جدید کنید"}
                </p>
            </DialogContent>
            <DialogActions>
                <CButton
                    text={'رفتن به بخش تنظیمات'}
                    icon={<icons.Fingerprint/>}
                    onClick={backToSetting}
                    action='info'
                />
            </DialogActions>
        </>
    );
}